import { useState, useEffect } from 'react'

import Api from 'services/api'

import { useSessionContext } from 'hooks/SessionContext'
import { DeviceStatus } from 'types/Device'

const useDeviceStatuses = () => {
  const { session: { dealerId } } = useSessionContext()

  const [deviceModels, setDeviceModels] = useState<Array<DeviceStatus>>([])
  const [isDeviceLoaded, setIsDeviceLoaded] = useState(false)

  useEffect(() => {
    setIsDeviceLoaded(false)

    if (!dealerId) return

    Api.Dealers.getDeviceStatus(dealerId)
      .then((res) => {
        setDeviceModels(res)
        setIsDeviceLoaded(true)
      })
      .catch(() => {
        setDeviceModels([])
        setIsDeviceLoaded(true)
      })
  }, [dealerId])

  return { deviceModels, isDeviceLoaded }
}

export default useDeviceStatuses
